import { render, staticRenderFns } from "./UserAvatarPreview.vue?vue&type=template&id=5ba66ca2&scoped=true&"
import script from "./UserAvatarPreview.vue?vue&type=script&lang=js&"
export * from "./UserAvatarPreview.vue?vue&type=script&lang=js&"
import style0 from "./UserAvatarPreview.vue?vue&type=style&index=0&id=5ba66ca2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba66ca2",
  null
  
)

export default component.exports